<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i class="fa fa-times" style="cursor: pointer;" (click)="cancel()"></i>
  </div>
</div>

<!-- Modal Body -->
@if (!minimise) {
<div class="modal-body">

@if (isLoading) {
<mat-progress-bar color="primary" mode="indeterminate">
</mat-progress-bar>
}

<div class="max-height">
  @if (!isLoading) {
<div class="ap-p-spacing-6">

    <ap-table #table [data]="firstRow" [striped]="false">
      <table>
        <caption class="sr-only">Entity summary</caption>
      <thead class="a-thead">
        <tr>
          <th><span>LEID</span></th>
          <th><span>Tax Code</span></th>
          <th><span>Reporting Period</span></th>
          <th><span>Entity Name</span></th>
          <th><span>Tax Type</span></th>
          <th><span>ME Code</span></th>
          <th><span>Currency</span></th>
          <th><span>HO LEID</span></th>
          <th><span>HO Tax Code</span></th>
          <th><span>HO Reporting Period</span></th>
          <th><span>HO Entity Name</span></th>
          <th><span>HO Tax Type</span></th>
          <th><span>Tax Year Begin</span></th>
          <th><span>Tax Year End</span></th>
          <th><span>Source System Flag</span></th>
        </tr>
      </thead>
      <tbody class="a-tbody tbody-regular tbody-hover entity-summary-body">
        @for (item of firstRow; track $index) {
<tr>
          <td>{{ item.LEID }}</td>
          <td>{{ item.CDR_NO }}</td>
          <td>{{ item.REPORTING_PERIOD }}</td>
          <td>{{ item.LE_NAME }}</td>
          <td>{{ item.LE_TAX_TYPE }}</td>
          <td>{{ item.ME_CODE }}</td>
          <td>{{ item.CURR }}</td>
          <td>{{ item.HO_LEID }}</td>
          <td>{{ item.HO_CDR_NO }}</td>
          <td>{{ item.HO_REPORTING_PERIOD }}</td>
          <td>{{ item.HO_LE_NAME }}</td>
          <td>{{ item.HO_TAX_TYPE }}</td>
          <td>{{ item.TAX_YEAR_BEGIN }}</td>
          <td>{{ item.TAX_YEAR_END }}</td>
          <td>{{ item.SOURCE_SYSTEM_FLAG }}</td>
        </tr>
}
      </tbody>
      </table>
    </ap-table>

  </div>
}
  @if (!isLoading) {
<section class="ap-p-spacing-6">

    @for (key of objectKeys(finalData); track $index) {
<div>
      <ap-panel [title]="'Partner ' + finalData[key][0].INDEX + ': ' + finalData[key][0].PTR_LE">
        @if (finalData[key][0].display == false) {
<i class="fa fa-plus-circle expand-icon"
          (click)="expandCollapse(key)" title="Expand"></i>
}
        @if (finalData[key][0].display == true) {
<i class="fa fa-minus-circle expand-icon"
          (click)="expandCollapse(key)" title="Collapse"></i>
}
        <strong>Partner {{ finalData[key][0].INDEX }}: {{ finalData[key][0].PTR_LE }}</strong>
        <br />
        <br />
        @if (!isLoading && finalData[key][0].display == true) {
<ap-table #basicTable [data]="finalData[key]"
          [striped]="true">
          <table>
        <caption class="sr-only">Partner sourcing amounts</caption>
          <thead class="a-thead">
            <tr>
              <th><label><b>Account</b></label></th>
              <th><label><b>Account Description</b></label></th>
              <th><label><b>Issue Key</b></label></th>
              <th><label><b>Country</b></label></th>
              <th><label><b>Trading Partner</b></label></th>
              <th><label><b>Partner Amount (Ptr Curr)</b></label></th>
              <th><label><b>Partner Amount (Pship Curr)</b></label></th>
              <th><label><b>BRANCH</b></label></th>
              <th><label><b>GENLIM</b></label></th>
              <th><label><b>PASSIVE</b></label></th>
              <th><label><b>TREATY</b></label></th>
              <th><label><b>901j</b></label></th>
            </tr>
          </thead>

          @if (finalData[key].length > 0) {
<tbody class="a-tbody tbody-regular tbody-hover">
            @for (body of finalData[key]; track $index) {
<tr>
              <td><label>{{ body.ACCT }}</label></td>
              <td><label>{{ body.ACCT_DESC }}</label></td>
              <td><label>{{ body.ISSUE_KEY }}</label></td>
              <td><label>{{ body.COUNTRY_CODE }}</label></td>
              <td><label>{{ body.TRADING_PTR_LE ? body.TRADING_PTR_LE : '' }}</label></td>
              <td><label>{{ body.PTR_AMT_PTR_CURR | number }}</label></td>
              <td><label>{{ body.PTR_AMT_PSHIP_CURR | number }}</label></td>
              <td><label><ap-field [styleClass]="'ap-form-field-my-wrapper branch-ip'" [disabled]="true">
                    <input appkit-field aria-label="BRANCH" [(ngModel)]="body.BRANCH" />
                  </ap-field></label></td>
              <td><label><ap-field [styleClass]="'ap-form-field-my-wrapper'">
                    <input appkit-field aria-label="GENLIM" [(ngModel)]="body.GENLIM"
                      (ngModelChange)="updateBasket({value: $event}, $event, body)" />
                  </ap-field></label></td>
              <td><label><ap-field [styleClass]="'ap-form-field-my-wrapper'">
                    <input appkit-field aria-label="PASSIVE" [(ngModel)]="body.PASSIVE"
                      (ngModelChange)="updateBasket({value: $event}, $event, body)" />
                  </ap-field></label></td>
              <td><label><ap-field [styleClass]="'ap-form-field-my-wrapper'">
                    <input appkit-field aria-label="TREATY" [(ngModel)]="body.TREATY"
                      (ngModelChange)="updateBasket({value: $event}, $event, body)" />
                  </ap-field></label></td>
              <td><label><ap-field [styleClass]="'ap-form-field-my-wrapper'">
                    <input appkit-field aria-label="901j" [(ngModel)]="body['901j']"
                      (ngModelChange)="updateBasket({value: $event}, $event, body)" />
                  </ap-field></label></td>
            </tr>
}
          </tbody>
}
          </table>
        </ap-table>
}
      </ap-panel>

    </div>
}
  </section>
}

</div>

</div>
}<!-- /modal-body -->

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          (click)="saveEntries()"
          [disabled]="isSaving || isLoading">
    @if (isLoading) {
<i class="fa fa-spinner fa-spin"></i>
}
    Save
  </button>
  <button class="cancel-button" (click)="cancel()">Cancel</button>
</div>
